import momentJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Button, Card, Col, Form, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { faUserEdit, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router-dom";
import { CheckLg, List, Table, TelephoneOutbound } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { getStaffExtSettings } from "../store/api/SystemSettingsAPI";
import { addOrUpdateStaff, getStaff, getStaffAttachments, getStaffLastCode } from "../store/api/StaffAPI";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { getAllProvinces, getCityList, getZoneList } from "../store/api/LocationAPI";
import Loader from "react-loader-spinner";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { clickToCall, isWebApp, keyIsLetterOrNumber, setErrorDialog } from "../../store/api/CommonFunctions";
import StaffAttachments from "../Components/Staff/StaffAttachments";
import StaffEvents from "../Components/Staff/StaffEvents";
import { getStaffEvents } from "../store/api/CustomerApi";
import AutoSendStaffSettings from "../Components/Staff/AutoSendStaffSettings";
import ModalAccountLevel3 from "../../Components/Modals/ModalAccountLevel3";


const AddEditStaff = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { id, isAgency } = useParams();
    const [birthDate, setBirthDate] = useState(null);
    const [staffInfo, setStaffInfo] = useState({});
    const [popUser, setPopUser] = useState({ show: false });
    const [popAgency, setPopAgency] = useState({ show: false });
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedAgency, setSelectedAgency] = useState(null);
    const [staffShareInfo, setStaffShareInfo] = useState({});
    const { register, handleSubmit, errors } = useForm();
    const [selectedAccLevel3, setSelectedAccLevel3] = useState(null);
    const [popAccLevel3, setPopAccLevel3] = useState({ show: false });
    const [staffIsLegalEntity, setStaffLegalEntity] = useState(false);
    const staffAgency = (isAgency?.toString().toLowerCase() === "true" ? "نماینده" : "تکنسین");
    const title = (Number(id) > 0 ? "ویرایش " : "ثبت ") + "اطلاعات " + staffAgency;
    const { staffExtSettings, cityList, zoneList, provinceList } =
        useSelector(state => {
            return {
                staffExtSettings: state.SystemSettingsReducer.staffExtSettings,
                cityList: state.locationDataReducer.cityList,
                zoneList: state.locationDataReducer.zoneList,
                provinceList: state.locationDataReducer.provinceList,
            }
        });
    const loadCityList = (provinceID) => {
        dispatch(getCityList(provinceID));
    }
    const loadZoneList = (cityID) => {
        dispatch(getZoneList(cityID));
    }
    const checkNationalCode = (Name) => {
        if (Name.length === 10) {
            if (Name === '1111111111' ||
                Name === '0000000000' ||
                Name === '2222222222' ||
                Name === '3333333333' ||
                Name === '4444444444' ||
                Name === '5555555555' ||
                Name === '6666666666' ||
                Name === '7777777777' ||
                Name === '8888888888' ||
                Name === '9999999999') {
                return false;
            }
            let c = parseInt(Name.charAt(9));
            let n = parseInt(Name.charAt(0)) * 10 +
                parseInt(Name.charAt(1)) * 9 +
                parseInt(Name.charAt(2)) * 8 +
                parseInt(Name.charAt(3)) * 7 +
                parseInt(Name.charAt(4)) * 6 +
                parseInt(Name.charAt(5)) * 5 +
                parseInt(Name.charAt(6)) * 4 +
                parseInt(Name.charAt(7)) * 3 +
                parseInt(Name.charAt(8)) * 2;
            let r = n - parseInt(n / 11) * 11;
            if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
                return false;
            }
            else {
                return true;
            }
        }
        else if (Name === '') {
            return true;
        }
        else {
            return false;
        }

    }
    function submitData(data) {
        data.StaffTransportationPercentShare = staffShareInfo.StaffTransportationPercentShare ?? staffInfo.StaffTransportationPercentShare ?? 0;
        data.StaffTransportationFixAmountShare = staffShareInfo.StaffTransportationFixAmountShare ?? staffInfo.StaffTransportationFixAmountShare ?? 0;
        data.StaffInstallCostPercentShare = staffShareInfo.StaffInstallCostPercentShare ?? staffInfo.StaffInstallCostPercentShare ?? 0;
        data.StaffInstallCostFixAmountShare = staffShareInfo.StaffInstallCostFixAmountShare ?? staffInfo.StaffInstallCostFixAmountShare ?? 0
        data.StaffRepairCostPercentShare = staffShareInfo.StaffRepairCostPercentShare ?? staffInfo.StaffRepairCostPercentShare ?? 0;
        data.StaffRepairCostFixAmountShare = staffShareInfo.StaffRepairCostFixAmountShare ?? staffInfo.StaffRepairCostFixAmountShare ?? 0;
        data.StaffUsedPartsCostPercentShare = staffShareInfo.StaffUsedPartsCostPercentShare ?? staffInfo.StaffUsedPartsCostPercentShare ?? 0;
        data.StaffUsedPartsCostFixAmountShare = staffShareInfo.StaffUsedPartsCostFixAmountShare ?? staffInfo.StaffUsedPartsCostFixAmountShare ?? 0;
        data.StaffExtraUsedPartsCostPercentShare = staffShareInfo.StaffExtraUsedPartsCostPercentShare ?? staffInfo.StaffExtraUsedPartsCostPercentShare ?? 0;
        data.StaffExtraUsedPartsCostFixAmountShare = staffShareInfo.StaffExtraUsedPartsCostFixAmountShare ?? staffInfo.StaffExtraUsedPartsCostFixAmountShare ?? 0;
        data.StaffExtraServicesCostPercentShare = staffShareInfo.StaffExtraServicesCostPercentShare ?? staffInfo.StaffExtraServicesCostPercentShare ?? 0;
        data.StaffExtraServicesCostFixAmountShare = staffShareInfo.StaffExtraServicesCostFixAmountShare ?? staffInfo.StaffExtraServicesCostFixAmountShare ?? 0;
        data.StaffMainCoAmountPaymentPercentShare = staffShareInfo.StaffMainCoAmountPaymentPercentShare ?? staffInfo.StaffMainCoAmountPaymentPercentShare ?? 0;
        data.StaffMainCoAmountPaymentFixAmountShare = staffShareInfo.StaffMainCoAmountPaymentFixAmountShare ?? staffInfo.StaffMainCoAmountPaymentFixAmountShare ?? 0;
        data.IsAgency = isAgency === "true";
        data.ID = id;
        data.BirthDate = birthDate;
        if (Array.isArray(data.IsActive)) {
            data.IsActive = data.IsActive.some(i => i === "on");
        }
        if (Array.isArray(data.IsBlackListed)) {
            data.IsBlackListed = data.IsBlackListed.some(i => i === "on");
        }
        if (Array.isArray(data.IsMiddleMan)) {
            data.IsMiddleMan = data.IsMiddleMan.some(i => i === "on");
        }
        if (Array.isArray(data.HasStorage)) {
            data.HasStorage = data.HasStorage.some(i => i === "on");
        }
        if (data.IsSaleAgent) {
            data.IsSaleAgent = 1;
        }
        else {
            data.IsSaleAgent = 0;
        }
        const onSuccess = (res) => {
            if (Number(res.ID) > 0) {
                if (!(Number(id) > 0)) {
                    history.push(`/Services/AddEditStaff/${isAgency}/${res.ID}`);
                }
                setErrorDialog(dispatch, "success", title);
                setStaffInfo(data);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, title);
            }
        }
        addOrUpdateStaff(data, onSuccess)
    }
    function onSelectInput(e) {
        e.target.select();
    }
    const popover = (
        (<Popover id="popover-basic" style={{ maxWidth: "500px" }} >
            <Popover.Title as="h3" className="headerStyle">
                <Table size={18
                } />&nbsp;
                جدول سهم تکنسین</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "6px", borderBottom: "3px solid #bb1370bd" }}>
                <table className="table" style={{ fontFamily: "Vazir", border: "1px solid gray" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "55%" }}>نوع هزینه</th>
                            <th style={{ width: "15%" }}>درصد</th>
                            <th style={{ width: "30%" }}>+مبلغ ثابت</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ backgroundColor: "#dfdfee" }}>
                            <td >ایاب و ذهاب</td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0} max={100}
                                    value={staffShareInfo?.StaffTransportationPercentShare ?? staffInfo?.StaffTransportationPercentShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffTransportationPercentShare: e.target.value })} /></td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0}
                                    value={staffShareInfo?.StaffTransportationFixAmountShare ?? staffInfo?.StaffTransportationFixAmountShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffTransportationFixAmountShare: e.target.value })} />
                            </td>
                        </tr>
                        <tr>
                            <td>دستمزد نصب</td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0} max={100}
                                    value={staffShareInfo?.StaffInstallCostPercentShare ?? staffInfo?.StaffInstallCostPercentShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffInstallCostPercentShare: e.target.value })} />
                            </td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0}
                                    value={staffShareInfo?.StaffInstallCostFixAmountShare ?? staffInfo?.StaffInstallCostFixAmountShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffInstallCostFixAmountShare: e.target.value })} /></td>
                        </tr>
                        <tr style={{ backgroundColor: "#dfdfee" }}>
                            <td>دستمزد تعمیر</td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0} max={100}
                                    value={staffShareInfo?.StaffRepairCostPercentShare ?? staffInfo?.StaffRepairCostPercentShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffRepairCostPercentShare: e.target.value })} />
                            </td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0}
                                    value={staffShareInfo?.StaffRepairCostFixAmountShare ?? staffInfo?.StaffRepairCostFixAmountShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffRepairCostFixAmountShare: e.target.value })} />
                            </td>
                        </tr>
                        <tr>
                            <td>سود قطعات مصرفی از انبار</td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0} max={100}
                                    value={staffShareInfo?.StaffUsedPartsCostPercentShare ?? staffInfo?.StaffUsedPartsCostPercentShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffUsedPartsCostPercentShare: e.target.value })} />
                            </td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0}
                                    value={staffShareInfo?.StaffUsedPartsCostFixAmountShare ?? staffInfo?.StaffUsedPartsCostFixAmountShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffUsedPartsCostFixAmountShare: e.target.value })} />
                            </td>
                        </tr>
                        <tr style={{ backgroundColor: "#dfdfee" }}>
                            <td>سود قطعات مصرفی متفرقه</td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0} max={100}
                                    value={staffShareInfo?.StaffExtraUsedPartsCostPercentShare ?? staffInfo?.StaffExtraUsedPartsCostPercentShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffExtraUsedPartsCostPercentShare: e.target.value })} /></td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0}
                                    value={staffShareInfo?.StaffExtraUsedPartsCostFixAmountShare ?? staffInfo?.StaffExtraUsedPartsCostFixAmountShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffExtraUsedPartsCostFixAmountShare: e.target.value })} />
                            </td>
                        </tr>
                        <tr>
                            <td>بهای خدمات اضافی</td>
                            <td><input type="number" className="tableRowInput" onFocus={onSelectInput} min={0} max={100}
                                value={staffShareInfo?.StaffExtraServicesCostPercentShare ?? staffInfo?.StaffExtraServicesCostPercentShare ?? 0}
                                onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffExtraServicesCostPercentShare: e.target.value })} /></td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0}
                                    value={staffShareInfo?.StaffExtraServicesCostFixAmountShare ?? staffInfo?.StaffExtraServicesCostFixAmountShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffExtraServicesCostFixAmountShare: e.target.value })} />
                            </td>
                        </tr>
                        <tr style={{ backgroundColor: "#dfdfee" }}>
                            <td>مبلغ دریافتی از (پرداختی به) شرکت مادر</td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0} max={100}
                                    value={staffShareInfo?.StaffMainCoAmountPaymentPercentShare ?? staffInfo?.StaffMainCoAmountPaymentPercentShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffMainCoAmountPaymentPercentShare: e.target.value })} />
                            </td>
                            <td>
                                <input type="number" className="tableRowInput" onFocus={onSelectInput} min={0}
                                    value={staffShareInfo?.StaffMainCoAmountPaymentFixAmountShare ?? staffInfo?.StaffMainCoAmountPaymentFixAmountShare ?? 0}
                                    onChange={e => setStaffShareInfo({ ...staffShareInfo, StaffMainCoAmountPaymentFixAmountShare: e.target.value })} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Popover.Content>
        </Popover>)
    );
    function showModalUser() {
        const onSelect = (data) => {
            if (staffInfo) {
                staffInfo.RelatedUserID = "";
                staffInfo.RelatedUserName = "";
            }
            setSelectedUser(data);
        }
        setPopUser({
            show: true,
            selectUserWithName: onSelect
        })
    }
    function showModalAgency() {
        setPopAgency({
            show: true,
            forAgency: isAgency?.toString().toLowerCase() === "true",
            onSelect: setSelectedAgency
        })
    }
    function onSelectTab(indx) {
        if (indx === 1) {
            dispatch(getStaffAttachments(id));
        }
        if (indx === 2) {
            dispatch(getStaffEvents({ IsStaff: true, CustomerID: id }));
        }
    }
    function showModalAccLevel3(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        setPopAccLevel3({
            show: true,
            value: e.key ?? "",
            setAccData: setSelectedAccLevel3,
            parentHardCode: "CashInTransit"
        })
    }
    function call(callNumber) {
        callNumber = callNumber.replace(" ", "");
        if (!callNumber || callNumber === "") {
            return;
        }
        const onCall = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تماس با تکنسین/نماینده");
            }

        }
        clickToCall(callNumber, onCall)
    }
    useEffect(() => {
        setBirthDate(null);
        setStaffInfo({});
        setSelectedUser(null);
        setSelectedAgency(null);
        setStaffShareInfo({});
        setSelectedAccLevel3(null);
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        dispatch(getStaffExtSettings());
        dispatch(getAllProvinces());
        if (!(Number(id) > 0)) {
            const onGet = (res) => {
                if (res.Code) {
                    setStaffInfo({ Code: res.Code });
                }
                else {
                    setStaffInfo("PENDING");
                }
            }
            getStaffLastCode(onGet);
        }
        else {
            const onGet = (res) => {
                if (res === "PENDING") {
                    setStaffInfo("PENDING");
                }
                else if (res.Data) {
                    setStaffLegalEntity(res.Data.Type === "حقوقی");
                    setStaffInfo(res.Data);
                    if (Number(res.Data.ProvinceID) > 0 && Number(res.Data.CityID) > 0) {
                        loadCityList(res.Data.ProvinceID);
                    }
                    if (Number(res.Data.ZoneID) > 0 && Number(res.Data.CityID) > 0) {
                        loadZoneList(res.Data.CityID);
                    }
                }
            }
            getStaff(id, onGet)
        }
    }, [id, isAgency])

    return (
        <div className="container-fluid mt-2">
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={Number(id) > 0 ? faUserEdit : faUserPlus} size="lg" />&nbsp;
                    {title}
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                    <ModalSelectStaff setPopSelectStaff={setPopAgency} popData={popAgency} />
                    <ModalAccountLevel3 popData={popAccLevel3} setAccLevel3Popup={setPopAccLevel3} />
                    <Tabs onSelect={index => onSelectTab(index)}>
                        <TabList>
                            <Tab>اطلاعات {staffAgency}</Tab>
                            <Tab disabled={!(Number(id) > 0)}>پیوست ها</Tab>
                            <Tab disabled={!(Number(id) > 0)}>رویدادها</Tab>
                            {isWebApp() && <Tab disabled={!(Number(id) > 0)}>تنظیمات توزیع خودکار</Tab>}
                        </TabList>
                        <TabPanel>
                            {staffInfo === "PENDING" && <div style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" height={30} width={30} /></div>}
                            {staffInfo !== "PENDING" &&
                                <form onSubmit={handleSubmit(submitData)}>
                                    <Row className="rowBorder">
                                        <Col md={1} className="form-group">
                                            <label className="ellipsisLabel">کد {staffAgency}: <span style={{ color: "red" }}>*</span></label>
                                            <Form.Control name="Code" ref={register({ required: true })} defaultValue={staffInfo?.Code ?? ""} readOnly={!(Number(staffInfo?.ID) > 0)} />
                                            {errors?.Code && <small className="errors">وارد کردن کد الزامی است</small>}
                                        </Col>
                                        {!staffIsLegalEntity &&
                                            <Col md={2} className="form-group">
                                                <label>نام {staffAgency}: </label><span style={{ color: "red" }}>*</span>
                                                <Form.Control name="FirstName" ref={register({ required: true })} defaultValue={staffInfo?.FirstName ?? ""} />
                                                {errors?.FirstName && <small className="errors">وارد کردن نام الزامی است</small>}
                                            </Col>
                                        }
                                        <Col md={2} className="form-group">
                                            <label>{`نام ${staffIsLegalEntity ? '' : 'خانوادگی'} ${staffAgency}`}: </label><span style={{ color: "red" }}>*</span>
                                            <Form.Control name="LastName" ref={register({ required: true })} defaultValue={staffInfo?.LastName ?? ""} />
                                            {errors?.LastName && <small className="errors">وارد کردن نام ${staffIsLegalEntity ? '' : 'خانوادگی'} الزامی است</small>}
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>کاربر مرتبط: </label>
                                            <input type="hidden" name="RelatedUserID" ref={register({})} readOnly value={selectedUser?.ID ?? staffInfo?.RelatedUserID ?? ""} />
                                            <Form.Control name="RelatedUserName" readOnly value={selectedUser?.Name ?? staffInfo?.RelatedUserName ?? ""} />
                                            <Button className="btn-input-tiny" style={{ top: "26px" }} onClick={showModalUser}><List size={20} /></Button>
                                        </Col>
                                        <Col md={1} className="form-group">
                                            <label className="ellipsisLabel">جنسیت/نوع: <span style={{ color: "red" }}>*</span></label>
                                            <select className="form-control" name="Type" ref={register({ required: true })} defaultValue={staffInfo?.Type ?? ""} onChange={e => setStaffLegalEntity(e.target.value === "حقوقی")}>
                                                <option value="">انتخاب کنید</option>
                                                <option value="مرد">مرد</option>
                                                <option value="زن">زن</option>
                                                <option value="حقوقی">حقوقی</option>
                                            </select>
                                            {errors?.Type && <small className="errors">انتخاب جنسیت/نوع الزامی است</small>}
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>کد ملی: </label>
                                            <Form.Control name="StaffNationalCode" ref={register({ validate: checkNationalCode })} defaultValue={staffInfo?.StaffNationalCode ?? ""} />
                                            {errors?.StaffNationalCode && <small className="errors">کد ملی وارد شده معتبر نیست</small>}
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>{isAgency?.toString().toLowerCase() === "true" ? 'نماینده اصلی:' : "نماینده/تکنسین اصلی"} </label>
                                            <input type="hidden" name="ParentStaffID" value={selectedAgency?.ID ?? staffInfo?.ParentStaffID ?? ""} readOnly ref={register({})} />
                                            <Form.Control name="ParentStaffName" value={selectedAgency?.LastName ?? staffInfo.ParentStaffName ?? ""} readOnly />
                                            <Button className="btn-input-tiny" style={{ top: "26px" }} onClick={showModalAgency}><List size={20} /></Button>
                                        </Col>
                                        <Col md={1} className="form-group">
                                            <label className="ellipsisLabel">کد دوم {staffAgency}:</label>
                                            <Form.Control name="Code2" ref={register({ })} defaultValue={staffInfo?.Code2 ?? ""}/>
                                        </Col>
                                        <Col className="form-group col-md-1">
                                            <label className="ellipsisLabel">تاریخ تولد: </label>
                                            <DatePicker isGregorian={false} timePicker={false} className="form-control" name="BirthDate" onChange={value => { setBirthDate(value.local("en").format("YYYY-MM-DD")); }}
                                                value={staffInfo?.BirthDate ? momentJalaali(staffInfo.BirthDate.substring(0, 10)) : birthDate ? momentJalaali(birthDate) : null} />
                                        </Col>
                                        <Col md={3} className="form-group">
                                            <label>متن پیامک تبریک تولد: </label>
                                            <Form.Control name="HappyBirthdaySMSBody" ref={register({})} defaultValue={staffInfo?.HappyBirthdaySMSBody ?? ""} />
                                        </Col>
                                        <Col md={3} className="form-group">
                                            <label>توضیحات: </label>
                                            <Form.Control as="textarea" name="StaffDescription" rows={1} ref={register({})} defaultValue={staffInfo?.StaffDescription} />
                                        </Col>
                                        {/* {isAgency?.toString() === "true" &&
                                            <Col md={1}  className="form-group">
                                                <label>درصد سهم از خدمات:</label>
                                                <Form.Control name="AgentServicePercentShare" type="number" ref={register({})} defaultValue={staffInfo?.AgentServicePercentShare ?? ""} />
                                            </Col>
                                        } */}
                                        <Col md={4} className="form-group" style={{ color: "blue" }}>
                                            <label>سایر:</label>
                                            <Row className="rowBorder mt-1" style={{ paddingTop: "10px", paddingBottom: "10px", borderColor: "gray" }} >
                                                <Col md={2} style={{ width: "max-content", paddingLeft: 2 }}>
                                                    <input type="checkbox" className="form-check-input" ref={register({})} name="IsBlackListed" defaultChecked={staffInfo?.IsBlackListed ?? false} style={{ marginLeft: "3px" }} />
                                                    لیست سیاه
                                                </Col>
                                                <Col md={3} style={{ width: "max-content", paddingLeft: 4, paddingRight: 4 }}>
                                                    <input type="checkbox" className="form-check-input" ref={register({})} name="HasStorage" defaultChecked={staffInfo?.HasStorage ?? false} style={{ marginLeft: "3px" }} />
                                                    انبار اختصاص یابد
                                                </Col>
                                                <Col md={3} style={{ width: "max-content", paddingLeft: 4, paddingRight: 4 }}>
                                                    <input type="checkbox" className="form-check-input" ref={register({})} name="IsSaleAgent" defaultChecked={staffInfo?.IsSaleAgent ?? false} style={{ marginLeft: "3px" }} />
                                                    عامل فروش
                                                </Col>
                                                <Col md={2} style={{ width: "max-content", paddingLeft: 4, paddingRight: 4 }}>
                                                    <input type="checkbox" className="form-check-input" ref={register({})} name="IsActive" defaultChecked={staffInfo?.IsActive ?? true} style={{ marginLeft: "3px" }} />
                                                    فعال
                                                </Col>
                                                <Col md={2} style={{ width: "max-content", paddingLeft: 4, paddingRight: 4 }}>
                                                    <input type="checkbox" className="form-check-input" ref={register({})} name="IsMiddleMan" defaultChecked={staffInfo?.IsMiddleMan ?? false} style={{ marginLeft: "3px" }} />
                                                    معرف
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="rowBorder mt-3">
                                        <div className="rowTitle">
                                            اطلاعات تماس
                                        </div>
                                        <Col md={2} className="form-group">
                                            <label>تلفن: </label>
                                            <Form.Control name="Phone" ref={register({})} defaultValue={staffInfo?.Phone ?? ""} />
                                            {Number(staffInfo?.ID) > 0 && staffInfo.Phone?.length > 3 &&
                                                <Button className="btn-input-tiny" onClick={() => call(staffInfo.Phone)} style={{ top: 26 }}><TelephoneOutbound size={22} /></Button>
                                            }
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>موبایل: </label>
                                            <Form.Control name="Mobile" ref={register({})} defaultValue={staffInfo?.Mobile ?? ""} />
                                            {Number(staffInfo?.ID) > 0 && staffInfo.Mobile?.length > 9 &&
                                                <Button className="btn-input-tiny" onClick={() => call(staffInfo.Mobile)} style={{ top: 26 }}><TelephoneOutbound size={22} /></Button>
                                            }
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>دورنگار: </label>
                                            <Form.Control name="Fax" ref={register({})} defaultValue={staffInfo?.Fax ?? ""} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>پست الکترونیک: </label>
                                            <Form.Control name="Email" ref={register({})} defaultValue={staffInfo?.Email ?? ""} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>استان: </label>
                                            {provinceList === "PENDING" &&
                                                <div className="form-control">
                                                    <Loader type="BallTriangle" color="#bb1370" width={25} height={25} />
                                                </div>
                                            }
                                            {provinceList && Array.isArray(provinceList) &&
                                                <select className="form-control" name="ProvinceID" ref={register({})} defaultValue={staffInfo?.ProvinceID ?? ""} onChange={e => loadCityList(e.target.value)}>
                                                    <option value="">انتخاب کنید</option>
                                                    {provinceList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                                </select>
                                            }
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>شهر: </label>
                                            {cityList === "PENDING" &&
                                                <div className="form-control"><Loader type="BallTriangle" color="#bb1370" width={25} height={25} /></div>}
                                            {cityList && Array.isArray(cityList) &&
                                                <select className="form-control" name="CityID" ref={register({})} defaultValue={staffInfo?.CityID ?? ""} onChange={e => loadZoneList(e.target.value)}>
                                                    <option value="">انتخاب کنید</option>
                                                    {cityList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                                </select>
                                            }
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>منطقه: </label>
                                            {zoneList === "PENDING" &&
                                                <div className="form-control"><Loader type="BallTriangle" color="#bb1370" width={25} height={25} /></div>}
                                            {zoneList && Array.isArray(zoneList) &&
                                                <select className="form-control" name="ZoneID" ref={register({})} defaultValue={staffInfo?.ZoneID ?? ""}>
                                                    <option value="">انتخاب کنید</option>
                                                    {zoneList.map((item, i) => <option key={i} value={item.Id}>{item.Name}</option>)}
                                                </select>
                                            }
                                        </Col>
                                        <Col md={4} className="form-group">
                                            <label>نشانی: </label>
                                            <Form.Control name="Address" ref={register({})} defaultValue={staffInfo?.Address ?? ""} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>کد پستی: </label>
                                            <Form.Control name="PostalCode" ref={register({})} defaultValue={staffInfo?.PostalCode ?? ""} />
                                        </Col>
                                    </Row>
                                    <Row className="rowBorder mt-3">
                                        <div className="rowTitle">حسابداری</div>
                                        <Col md={2} className="form-group">
                                            <label>حساب بانکی: </label>
                                            <Form.Control name="BankAccountInfo" ref={register({})} defaultValue={staffInfo?.BankAccountInfo ?? ""} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>کد حسابداری صندوق: </label>
                                            <input type="hidden" name="RelatedAccLevel3ID" value={selectedAccLevel3?.AccountID ?? staffInfo.RelatedAccLevel3ID ?? 0} readOnly ref={register({})} />
                                            <Form.Control name="RelatedAccLevel3Name" value={selectedAccLevel3?.AccountName ?? staffInfo.RelatedAccLevel3Name ?? ""} readOnly ref={register({})} onKeyDown={showModalAccLevel3} />
                                            <Button className="btn-input-tiny" onClick={showModalAccLevel3}><List size={20} /></Button>
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>نحوه محاسبه پورسانت فروش: </label>
                                            <select className="form-control" name="SalePercentCalcMethod" ref={register({})} defaultValue={staffInfo?.SalePercentCalcMethod ?? ""}>
                                                <option value={false}>برحسب سود فاکتور</option>
                                                <option value={true}>برحسب کل فاکتور</option>
                                            </select>
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>پورسانت فروش: </label>
                                            <Form.Control type="number" name="SalePoorsant" ref={register({})} defaultValue={staffInfo?.SalePoorsant ?? 0} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>سقف اعتبار: </label>
                                            <Form.Control type="number" name="TotalCredit" ref={register({})} defaultValue={staffInfo?.TotalCredit ?? 0} />
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>درصد و جدول سهم: </label>
                                            <Form.Control type="number" name="StaffPercentShare" ref={register({})} defaultValue={staffInfo?.StaffPercentShare ?? ""} />
                                            <OverlayTrigger trigger="click" placement="top" overlay={popover} rootClose>
                                                <Button className="btn-input-tiny"><Table size={20} /></Button>
                                            </OverlayTrigger>
                                        </Col>

                                    </Row>
                                    <Row className="rowBorder mt-3">
                                        <div className="rowTitle">
                                            سایر اطلاعات
                                        </div>
                                        {staffExtSettings && Array.isArray(staffExtSettings) &&
                                            staffExtSettings.map((ext, i) =>
                                                <Col md={2} className="form-group" key={i}>
                                                    <label>{ext.SettingValue}</label>
                                                    <Form.Control name={`ExtraAttr${i + 1}`} ref={register({})} defaultValue={staffInfo ? staffInfo[`ExtraAttr${i + 1}`] : ""} />
                                                </Col>)
                                        }
                                    </Row>
                                    <Button type="submit" className="mt-1 group-Btn-large" variant="success"><CheckLg />&nbsp;ثبت اطلاعات</Button>
                                </form>
                            }
                        </TabPanel>
                        <TabPanel>
                            <StaffAttachments staffID={id} />
                        </TabPanel>
                        <TabPanel>
                            <StaffEvents staffID={id} />
                        </TabPanel>
                        {isWebApp() &&
                            <TabPanel>
                                <AutoSendStaffSettings staffID={id} />
                            </TabPanel>
                        }
                    </Tabs>
                </Card.Body>
            </Card>
        </div>
    )

}
export default AddEditStaff;